import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { TextField } from '@mui/material';
import { api } from 'src/Api';

export default function OrderStatusDropDown({ setRole, fullWidth, alreadyRole }) {
  const [roles, setRoles] = useState([]);
  const [reasondrop, setReasondrop] = useState(null);

  useEffect(() => {
    const getRoles = async () => {
      const requestOptions = {
        method: 'GET', // 'GET' should be capitalized
        redirect: 'follow'
      };

      try {
        const response = await fetch(api.get_product_status, requestOptions);
        if (response.status === 200) {
          const result = await response.json();
          const rolesData = result.data;
          setRoles(rolesData);
          if (alreadyRole) {
            const defaultRole = rolesData.find((role) => role.name === alreadyRole) || null;
            setReasondrop(defaultRole);
          }
        } else {
          console.error('Error fetching roles:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };

    getRoles();
  }, [alreadyRole]);

  const handleChange = (event) => {
    const selectedRole = event.target.value;
    setRole(selectedRole?.name);
    setReasondrop(selectedRole);
  };

  return (
    <>
      <TextField
        fullWidth={fullWidth}
        style={{ width: !fullWidth && '20%', marginLeft: !fullWidth && 15 }}
        select
        value={reasondrop}
        label={'Select status'}
        onChange={handleChange}
      >
        <MenuItem value="" disabled>
          Select a status
        </MenuItem>
        {roles.map((option) => (
          <MenuItem key={option.id} value={option}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
